// react
import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'

// css
import '../../css/components/CreateDataFeedModal.styl'

// components
import {
  Button,
  BUTTON_THEME,
  Chip,
  Icon,
  Select,
  Form,
} from '@st-operations/uikit/src/v2/index.js'

// lib
import pretty from '@st-operations/uikit/lib/pretty.js'

const INITIAL_STATE = {
  name: '',
  client: '',
  type: [],
  events: [],
  fields: [],
  compression: '',
}

const CONTENT_SELECTION = ['type', 'events', 'fields']

const STEPS = {
  names: {
    order: 1,
    title: 'Basic Information',
  },
  content: {
    order: 2,
    title: 'Content Selection',
  },
}

// TODO: Create generic entity create form to reuse this modal across entities
const CreateDataFeedModal = ({ onClose }) => {
  const [step, setStep] = useState(1)
  const [schema, setSchema] = useState(null)
  const [item, setItem] = useState(INITIAL_STATE)
  const isLastStep = step === STEPS.content.order
  const numberOfSteps = Object.keys(STEPS).length

  useEffect(() => {
    if (!schema) {
      window._api.get(`/data-feeds/schema`, (error, schema) => {
        if (error) {
          toast.error(error.message)
        }

        if (schema) {
          setSchema(schema)
        }
      })
    }
  }, [schema])

  const createFeed = () => {
    // create data feed
    window._api.post('/data-feeds', item, (error, item) => {
      if (error) {
        toast.error(error.message)
      } else {
        onClose()
        window._history.push(`/data-feeds/${item._id}`)
      }
    })
  }

  const handleNextClick = () => {
    setStep((prevStep) => prevStep + 1)
  }

  const handleBackClick = () => {
    setStep((prevStep) => prevStep - 1)
  }

  const handleOnChange = (value, name) => {
    setItem((prevValues) => ({ ...prevValues, [name]: value }))
  }

  const handleMultiSelectClick = ({ value }, name) => {
    setItem((prevValues) => ({ ...prevValues, [name]: [...prevValues[name], value] }))
  }

  const handleRemoveValue = (value, { currentTarget: { name } }) => {
    setItem((prevValues) => ({
      ...prevValues,
      [name]: prevValues[name].filter((val) => pretty(val) !== value),
    }))
  }

  const getTitle = (currentStep) => {
    const step = Object.values(STEPS).find((step) => step.order === currentStep)
    return step.title
  }

  return (
    <div className="create-data-feed-modal">
      <div
        className="create-data-feed-modal__bar"
        style={{ width: `${(step / numberOfSteps) * 100}%` }}
      />
      <header className="create-data-feed-modal__header">
        <button
          arial-label="Close modal"
          className="create-data-feed-modal__close"
          onClick={onClose}
        >
          <Icon color="#000" height="16px" icon="delete" type="fill" width="16px" />
        </button>
        <div className="create-data-feed-modal__step" style={{ color: '#a3a3a3' }}>
          {`Step ${step} of ${numberOfSteps}`}
        </div>
        <p className="create-data-feed-modal__title">{getTitle(step)}</p>
      </header>
      <div className="create-data-feed-modal__content">
        {/* Names */}
        <If condition={step === STEPS.names.order}>
          <Form
            fields={[
              { name: 'name', label: 'Feed name' },
              { name: 'client', label: 'Client name' },
            ]}
            item={item}
            onChange={handleOnChange}
            schema={schema}
          />
        </If>

        {/* Content */}
        <If condition={step === STEPS.content.order}>
          <For each="field" of={CONTENT_SELECTION}>
            <Select
              label={pretty(field)}
              options={schema[field].enum.filter((option) => !item[field].includes(option))}
              isClearable={true}
              isSearchable={true}
              onChange={handleMultiSelectClick}
              name={field}
            />
            <If condition={item[field].length}>
              <p className="create-data-feed-modal__text">
                Selected {field}
                {item[field].length > 1 && field.slice(-1) !== 's' ? 's' : ''}
              </p>
              <For each="value" index="index" of={item[field]}>
                <Chip
                  containerClass="create-data-feed-modal__chip"
                  key={index}
                  onClick={handleRemoveValue}
                  name={field}
                  value={pretty(value)}
                />
              </For>
            </If>
          </For>
        </If>
      </div>
      <div className="create-data-feed-modal__buttons">
        <If condition={step > 1}>
          <Button
            className="create-data-feed-modal__button"
            onClick={handleBackClick}
            theme={BUTTON_THEME.SECONDARY}
          >
            Back
          </Button>
        </If>
        <Button
          className="create-data-feed-modal__button"
          onClick={isLastStep ? createFeed : handleNextClick}
        >
          {isLastStep ? 'Create feed' : 'Next'}
        </Button>
      </div>
    </div>
  )
}

export default withRouter(CreateDataFeedModal)
